const PageWrapper = ({ children, className }) => (
    <main className={`page-content ${className} pagePadding`}>
        {children}
    </main>
);
export default PageWrapper;